<template>
    <div>
        <div v-show="!shouldShowForm">
            <form-advanced-select
                    :name="name"
                    :slug="name"
                    :validations="['required']"
                    :values="creditCards"
                    ref="creditCard"
                    @change="setSelectedCreditCard"
                    :value="selectValue"
            >
                <div slot="placeholder" class="uk-padding-small uk-padding-remove-horizontal">
                    {{ $t('rubinred.ecommerce.payments.credit-cards.fields.placeholder') }}
                </div>
                <div slot="item" slot-scope="{item, index}" class="uk-padding-small uk-padding-remove-horizontal uk-flex uk-flex-wrap uk-flex-between@s">
                    <div class="uk-width-1-2@s">
                        {{ item.token }}
                    </div>
                    <div class="uk-width-1-2@s uk-text-right@s">
                        {{ item.description }}
                    </div>
                </div>
            </form-advanced-select>
            <p>
                <a class="uk-button uk-button-link" @click="deleteCreditCard" v-show="canDeleteCreditCard">
                    <i class="fal fa-trash-alt"></i> {{ $t('frontend-action.delete') }}
                </a>
                <a class="uk-button uk-button-link uk-margin-left" @click="addCreditCard">
                    <i class="fal fa-plus"></i> {{ $t('frontend-action.add') }}
                </a>
            </p>
        </div>
        <div v-show="shouldShowForm">
            <rubinred-form class="uk-form-stacked" ref="form">
                <div slot="fields" class="uk-grid-small" uk-grid>
                    <div class="uk-width-1-1">
                        <form-input
                                name="number"
                                slug="number"
                                :label="$t('rubinred.ecommerce.payments.credit-cards.fields.number')"
                                :validations="['required']"
                        >
                        </form-input>
                    </div>
                    <div class="uk-width-1-3">
                        <form-input
                                name="expMonth"
                                slug="expMonth"
                                :label="$t('rubinred.ecommerce.payments.credit-cards.fields.exp_month')"
                                :validations="['required']"
                        ></form-input>
                    </div>
                    <div class="uk-width-1-3">
                        <form-input
                                name="expYear"
                                slug="expYear"
                                :label="$t('rubinred.ecommerce.payments.credit-cards.fields.exp_year')"
                                :validations="['required']"
                        ></form-input>
                    </div>
                    <div class="uk-width-1-3">
                        <form-input
                                name="cvv"
                                slug="cvv"
                                :label="$t('rubinred.ecommerce.payments.credit-cards.fields.cvv')"
                                :validations="['required']"
                        ></form-input>
                    </div>
                    <div class="uk-width-1-1">
                        <form-checkboxes
                                name="remember"
                                slug="remember"
                                :values="{true: $t('rubinred.ecommerce.payments.credit-cards.fields.remember')}"
                        >
                        </form-checkboxes>
                    </div>
                </div>
            </rubinred-form>
            <div class="uk-align-right uk-margin-top" v-if="customer && Object.keys(this.creditCards).length > 0">
                <button @click="discardForm" class="uk-button uk-button-default">
                    {{ $t('frontend-action.back') }}
                </button>
                <button @click="submitCreditCard" class="uk-button uk-button-primary">{{ $t('frontend-action.save') }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
  export default {
    props: {
      customer: {
        type: Boolean,
      },
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      let initialValue = this.$store.state.checkout.payment.handlerData ? this.$store.state.checkout.payment.handlerData.creditCard : null;
      return {
        showForm: false,
        selectValue: initialValue ? initialValue.id : null,
        creatingCreditCard: false,
      };
    },
    computed: {
      selectedCreditCard() {
        return this.selectValue ? this.creditCards[this.selectValue] : null;
      },
      canDeleteCreditCard() {
        return !!this.selectedCreditCard;
      },
      creditCards() {
        return this.$store.state.wallet.creditCards;
      },
      shouldShowForm() {
        return Object.keys(this.creditCards).length === 0 || !this.customer || this.showForm;
      }
    },
    methods: {
      validate() {
        if (!this.shouldShowForm) {
          return !!this.selectValue;
        }

        return this.$refs.form.performValidation();
      },

      getValues() {
        if (!this.shouldShowForm) {
          return {[this.name]: this.selectValue};
        }

        return this.submitCreditCard();
      },

      deleteCreditCard() {
        this.$store.dispatch('wallet/remove', this.selectedCreditCard).then(response => {
          if (!response.data.success) {
            return;
          }
          this.setSelectedCreditCard(null);
        });
      },
      addCreditCard() {
        this.creatingCreditCard = true;
        this.$refs.form.resetValues();
        this.$refs.form.resetValidations();
        this.showForm = true;
      },
      discardForm() {
        this.showForm = false;
      },
      setSelectedCreditCard(value) {
        this.selectValue = value;
      },
      submitCreditCard() {
        if (!this.$refs.form.performValidation()) {
          return false;
        }
        let data = this.$refs.form.getValues();
        if (!this.creatingCreditCard && this.selectedCreditCard) {
          data.id = this.selectedCreditCard.id;
        }
        return this.$store.dispatch('wallet/submit', data).then(response => {
          if (!response.data.success) {
            return false;
          }
          if (this.creatingCreditCard) {
            this.selectValue = response.data.creditCard.id;
          }
          this.discardForm();

          return {[this.name]: response.data.creditCard.id};
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/CreditCardPicker.vue